import { CustomerModel } from 'api-hooks/customer';
import Popover from 'components/popover';
import * as React from 'react';

import useCustomerGuestListAction from '../hooks/use-customer-guest-list-action';
import useCustomerSuspendAction from '../hooks/use-customer-suspend-action';
import useCustomerUnsuspendAction from '../hooks/use-customer-unsuspend-action';

interface Props {
  customer: CustomerModel;
}

export default function ActionComponent(props: Props) {
  const { customerGuestListAction } = useCustomerGuestListAction(
    props.customer,
  );
  const { customerSuspendAction } = useCustomerSuspendAction(props.customer);
  const { customerUnsuspendAction } = useCustomerUnsuspendAction(
    props.customer,
  );

  const actions = [
    customerGuestListAction,
    customerSuspendAction,
    customerUnsuspendAction,
  ].filter((action) => action.isAllowed);

  if (actions.length === 0) return null;

  return (
    <>
      <Popover actions={actions} />
    </>
  );
}
